export default "__VITE_ASSET__Bes$peEl__"